package fr.frux.feature.treedetail.photos

import fr.frux.feature.treedetail.TreeDetailState
import fr.frux.shared.domain.photos.PhotoUploadState
import fr.frux.shared.domain.photos.TreePhotoUploads
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

/**
 * Photos envoyées après la création de l'arbre (#633), vues depuis sa fiche, extraites de
 * `TreeDetailViewModel` (ratchet detekt LargeClass).
 *
 * Les échecs sont exposés dans l'état pour que l'écran propose « Réessayer » et « Retirer ». Une
 * photo envoyée déclenche un rechargement de la fiche, puis la file l'oublie. Sans file
 * ([uploads] nul), rien n'est collecté.
 */
class PendingPhotosController internal constructor(
    private val treeId: Long,
    private val uploads: TreePhotoUploads?,
    scope: CoroutineScope,
    private val state: MutableStateFlow<TreeDetailState>,
    private val reload: () -> Unit,
) {
    init {
        uploads?.let { queue ->
            scope.launch {
                queue.uploads.map { it[treeId].orEmpty() }.distinctUntilChanged().collect { photos ->
                    val failed = photos.filter { it.state == PhotoUploadState.Failed }.map { it.id }
                    state.update { it.copy(failedPhotoIds = failed) }
                    if (photos.any { it.state == PhotoUploadState.Sent }) {
                        reload()
                        queue.forgetSent(treeId)
                    }
                }
            }
        }
    }

    /** Renvoie toutes les photos en échec de l'arbre. */
    fun retry() = forEachFailed { uploads?.retry(treeId, it) }

    /** Oublie toutes les photos en échec de l'arbre. */
    fun remove() = forEachFailed { uploads?.remove(treeId, it) }

    private fun forEachFailed(action: (String) -> Unit) = state.value.failedPhotoIds.forEach(action)
}
